export default "__VITE_ASSET__CVyyjHOP__"